/**
 * Strips a protocol off a url
 *
 * @param {String} url
 */
export function stripProtocol(url) {
  return url.replace(/(^\w+:|^)\/\//, "");
}
